import { Tooltip, message } from 'antd';
import { useState } from 'react';
import { Stripe } from 'stripe';
import { useMutation, UseMutationOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { apiV1 } from '../../utils/apiClient';
import React from 'react';
import CModal from '../CModal';
import { IconRefreshOff } from '@tabler/icons-react';
import { subscriptionQueryOptions } from '../../utils/queryOptions';
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkBadge01Icon } from '@hugeicons/core-free-icons';
import { NButton, NTag } from '@next-is-free-monorepo/nif-web-components';
import { $api } from '../../utils/openApiClient';
import ChoosePlanModal from './ChoosePlanModal';
import { planFeaturesSummary } from '@next-is-free-monorepo/next-is-free-types';

const SubscriptionOverview = () => {

  const { data: subscription } = $api.useSuspenseQuery('get', '/shop/subscription');

  const [autoRenewModalOpen, setAutoRenewModalOpen] = useState(false);
  const [cancelRenewModalOpen, setCancelRenewModalOpen] = useState(false);
  const [choosePlanModalType, setChoosePlanModal] = useState<undefined | 'promo_code' | 'default'>(undefined);

  const queryClient = useQueryClient();
  const toggleAutoRenewMutation: UseMutationOptions = {
    mutationKey: ['subscription', 'renew'],
    mutationFn: async () => apiV1.put(`/shop/subscription/${subscription.id}/auto-renew/${subscription.cancel_at_period_end}`, {}),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['upcoming-invoice'] });
      message.success('Impostazioni di rinnovo aggiornate');
      setAutoRenewModalOpen(false);
      setCancelRenewModalOpen(false);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['subscription'] });
    }
  };

  const toggleAutoRenew = useMutation(toggleAutoRenewMutation);

  const labels = {
    starter: 'Starter',
    essential: 'Basic',
    advanced: 'Pro',
    enterprise: 'Enterprise'
  }

  return (
    <div>
      <div className={`bg-slate-900 p-5 rounded-2xl text-white`} title={'Piano attuale'}>
        <div className={'flex justify-between items-start'}>
          <div>
            <p className={'text-slate-300'}>Piano attuale</p>
            <p
              className={`text-2xl mt-2 font-semibold capitalize ${!subscription.is_subscription_valid && 'line-through'}`}>{labels[subscription.subscription_plan]}</p>
            {subscription.extra_sales_points_number > 0 &&
              <p>+{subscription.extra_sales_points_number} Punt{subscription.extra_sales_points_number === 1 ? 'o' : 'i'} vendita
                extra</p>
            }
            <div className={'mt-3 text-slate-200 space-y-1 '}>
              {planFeaturesSummary[subscription.subscription_plan].map((feature) => (
                <div key={feature} className={'flex gap-1 text-slate-300'}>
                  <HugeiconsIcon className={'flex-shrink-0 mt-1'} size={14} icon={CheckmarkBadge01Icon} />
                  <p>{feature}</p>
                </div>
              ))}
            </div>
          </div>
          <SubscriptionStatusCip renewalDate={subscription.renewal_date} status={subscription.status} />
        </div>
        <div>
          {/*   {subscription.cancel_at ?
            <p className={'bg-amber-50 w-fit pt-0.5 px-1 text-amber-500 mt-3 border border-amber-200 rounded-md'}>L'abbonamento terminerà
              il {dayjs(subscription.cancel_at * 1000).format('DD/MM/YY')} e non sarà rinnovato</p> :
            <p style={{ marginTop: 6, color: grey[2] }}>L'abbonamento sarà rinnovato automaticamente
              il {subscription.renewal_date}</p>
          }*/}
        </div>
        <div className={'flex justify-end gap-2 mt-8'}>
          <NButton onClick={() => setChoosePlanModal('promo_code')}
                   className={'text-white bg-slate-800 hover:bg-slate-700'}
                   color={'secondary'}>
            Ho un codice sconto
          </NButton>
          {/*    {subscription.cancel_at ?
            <Button loading={toggleAutoRenew.isPending} onClick={() => toggleAutoRenew.mutate()}>Attiva rinnovo automatico</Button> :
            <Button onClick={() => setCancelRenewModalOpen(true)}>Disattiva rinnovo automatico</Button>
          }*/}

          {/*Nascondi quando utente non ha ancora scelto un piano durante la prova gratis*/}
          {!(subscription.cancel_at_period_end && subscription.status === 'trialing') &&
            <NButton className={'bg-slate-50'} color={'tertiary'} onClick={() => {
              setChoosePlanModal('default');
            }}> {subscription.is_subscription_valid ? 'Modifica Piano' : 'Scegli un Piano'} </NButton>
          }
        </div>
      </div>
      <CModal title={'Disattivare il rinnovo?'}
              text={' L\'abbonamento sarà annullato al termine del periodo di fatturazione\n' +
                '          corrente.'} color={'red'} confirmButtonText={'Disattiva'}
              cancelButtonText={'Non disattivare'} open={cancelRenewModalOpen}
              onClose={() => setCancelRenewModalOpen(false)}
              icon={<IconRefreshOff />} mutationOptions={toggleAutoRenewMutation} />
      <ChoosePlanModal type={choosePlanModalType} open={!!choosePlanModalType}
                       onClose={() => setChoosePlanModal(undefined)} />
    </div>
  );
};
export default SubscriptionOverview;

function SubscriptionStatusCip({ status, renewalDate }: { status: Stripe.Subscription.Status, renewalDate: string }) {

  switch (status) {
    case 'active':
      return (
        <p className={'bg-green-100 text-green-700 px-2 text-sm py-0.5 rounded-md'}>
          Attivo
        </p>
      );
    case 'unpaid':
      return (
        <NTag color={'error'}>
          Insoluto
        </NTag>
      );
    case 'past_due':
      return (
        <Tooltip
          title={'Una o più fatture non sono state pagate. Controlla tra le fatture. Se una fattura è in sospeso significa che la banca sta ancora processando il pagamento, lo stato dell abbonamento tornerà attivo non appena il pagamento sarà completato, nel frattempo puoi continuare a usare Next is free senza interruzioni'}>
          <p className={'bg-red-100 text-red-700 px-2 text-sm py-0.5 rounded-md'}>
            Insoluto
          </p>
        </Tooltip>
      );
    case 'trialing':
      return (
        <NTag color={'info'}>
          In prova fino al {renewalDate}
        </NTag>
      );

    default:
      return (
        <NTag color={'error'}>
          Scaduto
        </NTag>
      );
  }
}
